
      <router-outlet></router-outlet>
      <!-- Live Chat Coming Soon -->
      <!-- <div class="bold360 bold360-green" id="contact-us"> -->
      <!-- <div class="bold360-button-contact" style="text-align: center !important;top: 17px !important;left: 0px !important;">Live Chat Coming Soon</div> -->
      <!-- Spinner -->
      <app-spinner class="justify-content-center align-items-center undisplayed"></app-spinner>
  